import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ChatbotMetadataComponent } from './chatbot-metadata/chatbot-metadata.component';

/**
 * Metadata Module
 *
 * Declares and exports ChatbotMetadataComponent so it can be used by
 * both the chatbot and agents modules without circular dependencies.
 */
@NgModule({
  declarations: [ChatbotMetadataComponent],
  imports: [CommonModule, TranslateModule],
  exports: [ChatbotMetadataComponent]
})
export class MetadataModule {}
